<template>
  <div class="componentRoot" v-if="userData || profileView">
    <v-card class="pa-4 mb-16" v-if="user">
      <UserEditContentVue
        :userData="user"
        :readonly="!$checkFunctionPermission(['user_patch_detail'])"
        :autosave="true"
        :refreshDisplay="refreshEditDrawer"
        @refresh="fetchData()"
      />
    </v-card>
  </div>
</template>

<script>
import UserEditContentVue from "../../../../components/user/UserEditContent.vue";

export default {
  props: ["userData"],
  data() {
    return {
      user: undefined,
      refreshEditDrawer: 0,
    };
  },

  components: {
    UserEditContentVue,
  },

  computed: {
    profileView(){
      return this.$route.path.startsWith("/main")
    }
  },

  methods: {
    fetchData() {
      this.refreshing = true;

      let url = "user/users/overview/" 

      return new Promise((resolve, reject) => {
        this.axios
          .get(
            this.axios.defaults.baseURL +
              url +
              (this.$route.params.userID ? this.$route.params.userID : ("own/" + this.$store.state.id))
          )
          .then((resp) => {
            this.user = resp.data;
            ++this.refreshEditDrawer;
            resolve();
          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
            reject();
          });
      });
    },
    getReadableDate(date) {
      if (date) return this.$moment(date).format("DD.MM.YYYY");
      else return undefined;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
